import React from 'react';
import { Container, Row, Col, Card, CardBody, CardTitle, CardText, Button } from 'reactstrap';
import { FaCheckCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const SuccessPage = () => {

  const navigate = useNavigate()

  return (
  
<Container className="text-center my-5">
      <Row className="justify-content-center">
        <Col md="6">
          <Card className="shadow-sm">
            <CardBody>
              <FaCheckCircle size={60} color="green" className="mb-4" />
              <CardTitle tag="h2" className="mb-3">
                Booking Completed Successfully!
              </CardTitle>
              <CardText>
                Thank you for your booking. We have sent a confirmation email with all the details.
              </CardText>
              <Button color="primary" className="mt-3" onClick={()=> navigate('/allBookings')}>
                Go to Dashboard
              </Button>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default SuccessPage

